import { Controller } from "@hotwired/stimulus"

// The Delays tab's Reissues by Year (brands/_reissues): a bar a year, how many
// reissues opened for pre-order; hovering one names them.
//
//   <div data-controller="reissues-chart" data-reissues-chart-years-value='{"2020":["Jason Voorhees"]}'>
//     <canvas data-reissues-chart-target="canvas"></canvas>
export default class extends Controller {
  static targets = ["canvas"]
  static values = { years: Object }

  connect() {
    const years = this.yearsValue
    const labels = Object.keys(years)
    this.chart = new Chart(this.canvasTarget, {
      type: "bar",
      data: { labels, datasets: [ { data: labels.map(y => years[y].length), backgroundColor: "#EAB308", borderRadius: 4, maxBarThickness: 40 } ] },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: (items) => `${items[0].label}: ${items[0].raw} reissue${items[0].raw === 1 ? "" : "s"}`,
              label: (item) => years[item.label].length ? years[item.label] : "none"
            }
          }
        },
        scales: {
          y: { beginAtZero: true, ticks: { stepSize: 1, color: "#9CA3AF" }, grid: { color: "rgba(75, 85, 99, 0.2)" } },
          x: { grid: { display: false }, ticks: { color: "#9CA3AF" } }
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
